document.addEventListener('alpine:init', () => {
  var klaviyo = window.klaviyo || [];

  Alpine.store("cart", {
    loaded: false,
    data: {},
    beforeAjax() {
      Alpine.store("ajaxWorking", true);
    },
    afterAjax(add = false) {
      // Alpine.store("ajaxWorking", false);
      if (!document.body.classList.contains("template--cart")) {
        Alpine.store("cartOpen", true);
      }
      this.getCartData(add);
    },
    getCartData(add = false) {
      fetch(`${Shopify.routes.root}cart.js`)
        .then((res) => res.json())
        .then((json) => {
          this.loaded = true;
          this.data = {
            ...json,
            // If need to filter hidden items, do it here.
            quantity: json.items.reduce((a, b) => a + b.quantity, 0)
          };
          Alpine.store("ajaxWorking", false); //  Moved to here so not to show pause between queries.

          //Klaviyo tracking
          if (add) {
            klaviyo.push([
              "track",
              "Added to Cart",
              {
                total_price: this.data.total_price / 100,
                $value: this.data.total_price / 100,
                total_discount: this.data.total_discount,
                original_total_price: this.data.original_total_price / 100,
                items: this.data.items,
              },
            ]);
          }
        })
        // .error(() => Alpine.store("ajaxWorking", false));
    },
    clear() {
      this.beforeAjax();
      fetch(`${Shopify.routes.root}cart/clear.js`, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
      }).then((response) => {
        if (response.ok) {
          // this.$dispatch('cart-update');
        }
        this.cartError = !response.ok;
        this.afterAjax();
      });
    },
    addCartItem(variantId, quantity = 1, properties = {}, selling_plan = false) {
      this.beforeAjax();
      fetch(`${Shopify.routes.root}cart/add.js`, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity,
          properties: properties,
          ...(selling_plan ? { selling_plan: selling_plan }: {})
        }),
      }).then((response) => {
        if (response.ok) {
        }
        this.cartError = !response.ok;
        this.afterAjax(true);
      });
    },
    updateCartItem(variantIdOrKey, quantity = 1, callback = () => null) {
      const matchingCartItems = this.data.items.filter(
        (cartItem) =>
          cartItem.variant_id == variantIdOrKey ||
          cartItem.key == variantIdOrKey
      );
      const add =
        matchingCartItems.length > 0 &&
        matchingCartItems[0].quantity < quantity;
      this.beforeAjax();
      fetch(`${Shopify.routes.root}cart/change.js`, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          id: variantIdOrKey,
          quantity: quantity,
        }),
      }).then((response) => {
        if (response.ok) {
        }
        this.cartError = !response.ok;
        this.afterAjax(add);

        return response.json();
      }).then((res) => {
        // if (cart.status == 200) {
        //   callback(cart)
        // }
        // else {
          // this.getCartData();
        // }
        callback(res);
      });
    },
    removeCartItem(variantId) {
      this.updateCartItem(variantId, 0);
    },
  });

  //Can call the update via
  window.updateAlpineCart = () =>
    document
      .querySelector('body')
      .dispatchEvent(new CustomEvent('cart-update'));

  // Alpine.start();
});
